const DRIVING_POSITION_TEMPLATE = 22

interface DrivingPosition {
  requirements?: string | null
  positionTemplateId?: number | null
}

export function isDrivingPosition(position?: DrivingPosition | null) {
  if (!position) {
    return false
  }

  return (
    position.requirements?.includes('Valid drivers license') ||
    position.positionTemplateId === DRIVING_POSITION_TEMPLATE
  )
}
